<div class="activity-details modal-view" c-toggle="showActivity">
    <!--<c-auto-form config="autoFormConfig"></c-auto-form>-->
    <div c-activity activity="activity" activity-group="activityGroup"></div>
</div>